import * as Sentry from "@sentry/browser";
import { storageKeys } from "./localStorageUtils";
import { FMSLogger } from "FMSLogger";

const sentryUtilsLogger = FMSLogger.byPrefix("sentryUtils");

// Set Sentry user context using user data
export const setSentryUser = (userData: {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  role?: string;
}) => {
  sentryUtilsLogger.info("setSentryUser", userData);
  Sentry.setUser({
    id: userData.id,
    email: userData.email,
    username:
      userData.firstName && userData.lastName
        ? `${userData.firstName} ${userData.lastName}`
        : undefined,
    segment: userData.companyName,
    role: userData.role,
  });
};

// Set Sentry user context from localStorage (for app startup)
export const setSentryUserFromStorage = () => {
  const userId = localStorage.getItem(storageKeys.USER_ID);
  const firstName = localStorage.getItem(storageKeys.USER_FIRST_NAME);
  const lastName = localStorage.getItem(storageKeys.USER_LAST_NAME);
  const company = localStorage.getItem(storageKeys.USER_COMPANY);
  const email = localStorage.getItem(storageKeys.USER_EMAIL);
  const role = localStorage.getItem(storageKeys.USER_ROLE);

  if (userId || email) {
    setSentryUser({
      id: userId || undefined,
      email: email || undefined,
      firstName: firstName || undefined,
      lastName: lastName || undefined,
      companyName: company || undefined,
      role: role || undefined,
    });
  }
};

// Clear Sentry user context (for logout)
export const clearSentryUser = () => {
  Sentry.setUser(null);
};

export const sendSentryEvent = (
  error: Error,
  errorType: string,
  userText = ""
) => {
  Sentry.withScope((scope) => {
    scope.setExtra("date", new Date());
    scope.setExtra("userText", userText);
    // User context is now set globally via Sentry.setUser, no need to set it per event
    Sentry.captureException(error || new Error(errorType));
  });
};
